<template>
  <v-app id="inspire">
    <div class="details-wrap">
      <div class="details-header">
        <div class="details-header-back">
          <p class="header-title title-name mb-0">
            Unassigned Locations:<span class="headline"> {{ address }} </span
            ><br />
            <span class="upp"> {{ full_name }} </span>
            <template v-if="pricing_plan_name">
              on <span class="upp"> {{ pricing_plan_name }} </span>
              <template v-if="service_plan_name">
                - {{ service_plan_name }}
              </template>
            </template>
          </p>
          <v-btn class="header-btn-back mr-0 mb-3" @click="$router.go(-1)">
            <v-icon class="header-btn-back-icon">navigate_before</v-icon>
            Back
          </v-btn>
        </div>
        <div style="clear: both;"></div>
        <v-layout class="xs12 wrap justify-end">
          <v-menu offset-y bottom left>
            <template v-slot:activator="{ on }">
              <v-btn class="mr-0" v-on="on" icon>
                <v-icon color="#999">more_vert</v-icon>
              </v-btn>
            </template>
            <v-list class="pa-0">
              <v-list-item @click="editGeolocationModal(location)">
                <v-list-item-title
                  ><v-icon color="primary" class="mr-2">edit_location</v-icon>
                  Adjust Geolocation</v-list-item-title
                >
              </v-list-item>
            </v-list>
          </v-menu>
          <v-btn
            color="primary"
            dark
            class="mr-0"
            @click="assignLocationModal(items[0])"
          >
            <v-icon left>assignment_turned_in</v-icon>
            Assign
          </v-btn>
        </v-layout>
      </div>
      <v-card>
        <v-data-table
          :headers="headers"
          :items="items"
          :loading="loading"
          loader-height="2"
          class="elevation-1 details-table"
          hide-default-footer
          mobile-breakpoint="100"
        >
          <template v-slot:item="{item}">
            <tr>
              <td>Location ID</td>
              <td>{{ item.id }}</td>
            </tr>
            <tr>
              <td>Client Name</td>
              <td>{{ item.full_name }}</td>
            </tr>
            <tr>
              <td>Address</td>
              <td>{{ item.address }}</td>
            </tr>
            <tr>
              <td>City</td>
              <td>{{ item.city }}</td>
            </tr>
            <tr>
              <td>Zip</td>
              <td>{{ item.zip }}</td>
            </tr>
            <tr>
              <td>Sign Up Date and Time</td>
              <td>{{ item.created_at }}</td>
            </tr>
            <tr v-if="item.service_plan_name !== null">
              <td>Service Plan</td>
              <td>{{ item.service_plan_name }}</td>
            </tr>

            <tr v-if="item.pricing_plan_name !== null">
              <td>Pricing Plan</td>
              <td>{{ item.pricing_plan_name }}</td>
            </tr>

            <tr v-if="item.subscription_id !== null">
              <td>Subscription ID</td>
              <td>
                <v-layout
                  v-if="!no_data.includes(item.subscription_id)"
                  style="margin-left: -14px;"
                >
                  <v-menu bottom right d-inline-flex>
                    <template v-slot:activator="{ on }">
                      <v-btn class="ma-0" v-on="on" icon>
                        <v-icon color="#999">more_vert</v-icon>
                      </v-btn>
                    </template>
                    <v-list class="pa-0">
                      <v-list-item
                        @click="
                          $router.push(
                            '/subscription/' +
                              item.subscription_id +
                              '/show'
                          )
                        "
                      >
                        <v-flex class="body-1">
                          <v-icon class="mr-2" color="primary" size="18px"
                            >visibility</v-icon
                          >
                          View Subscription Details
                        </v-flex>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                  <v-layout class="wrap align-center">
                    <v-flex>{{ item.subscription_id }}</v-flex>
                  </v-layout>
                </v-layout>
                <em v-else class="grey--text">No data</em>
              </td>
            </tr>
          </template>
        </v-data-table>

        <edit-unassigne-schedule
          @done="redirectToSchedule($event)"
        ></edit-unassigne-schedule>
        <edit-geolocation @done="getDataFromApi"></edit-geolocation>
      </v-card>
    </div>
  </v-app>
</template>

<script>
import ApiService from "@/common/api.service";
import EditUnassigneSchedule from "../EditUnassigneSchedule.vue";
import EditGeolocation from "../EditGeolocation/EditGeolocation.vue";
import { mapActions } from 'vuex'

export default {
  name: "UnassignedShow",
  components: {
    EditUnassigneSchedule,
    EditGeolocation
  },
  data() {
    return {
      items: [],
      no_data: [null, "", undefined, "null"],
      address: "",
      full_name: "",
      pricing_plan_name: "",
      service_plan_name: "",
      loading: true,
      headers: [
        {
          text: "Details",
          align: "left",
          sortable: false,
          value: "conditions"
        },
        {
          text: "",
          value: "results",
          sortable: false
        }
      ],
      service_plan: ""
    };
  },
  mounted() {
    this.getDataFromApi();
  },
  methods: {
    ...mapActions(['vEmit']),
    getDataFromApi(id = this.$route.params.id) {
      this.loading = true;
      ApiService.get("/scheduler/show", { id: id }).then(response => {
        this.loading = false;
        this.location = response.data.location;
        this.items = [response.data.location];
        this.address = response.data.location.address;
        this.full_name = response.data.location.full_name;
        this.pricing_plan_name = response.data.location.pricing_plan_name;
        this.service_plan_name = response.data.location.service_plan_name;
      });
    },
    assignLocationModal(item) {
      this.vEmit({ name: "AssignLocation", data: item })
    },
    editGeolocationModal(item) {
      this.vEmit({ name: "EditGeoLocation", data: item })
    },

    removeUnderScore(str) {
      for (let i in str) {
        str = str.replace("_", " ");
      }
      return str;
    },
    redirectToSchedule(id) {
      this.$router.push("/schedule/" + id + "/show");
    }
  }
};
</script>

<style scoped>
/*Remove action controls form table*/
.details-wrap .datatable__actions {
  display: none;
}

.upp {
  text-transform: uppercase;
}

.dialog-heading {
  background-color: #efefef;
  padding: 10px;
}
</style>
